import { Button, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import OnboardingLayout from '../OnboardingLayout';

const useStyles = makeStyles((theme) => ({
  cabecalho: {
    textAlign: 'right',
    marginTop: '5%',
  },
  titulo: {
    fontSize: '36px',
    fontWeight: 800,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.11,
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#2e62b8',
  },
  btnAvancar: {
    borderRadius: '48px',
    textTransform: 'capitalize',
    backgroundColor: '#2e62b8',
    width: '100%',
    marginTop: '5%',
  },
  break: {
    flexBasis: '100%',
    height: '5vw',
  },
  logoFatureMais: {
    alignItems: 'center',
    bottom: '3%',
    width: '200px',
    height: '69px',
  },
  logoGroupFinanceiro: {
    bottom: '2.5%',
    width: '164px',
    height: '60px',
    marginLeft: '2%',
  },
}));

const FinalApresentacaoOnboarding = () => {
  const classes = useStyles(useStyles);
  return (
    <OnboardingLayout
      content={
        <>
          <Grid container style={{ marginTop: '11%' }}>
            <Grid item lg={2} md={2} sm={2} xs={2} />
            <Grid item lg={4} md={4} sm={4} xs={10}>
              <img src={'assets/images/onboarding/6.svg'} alt="" />
            </Grid>

            <Grid item lg={4} md={4} sm={4} xs={12}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <label className={classes.titulo}>Nós te admiramos! Vamos apoiar seu negócio a todo momento.</label>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <label>
                  {' '}
                  <br />
                  Se você está aqui é porque tem uma grande habilidade no gerenciamento do seu negócio. A partir de
                  agora você poderá se beneficiar de toda a automação empresarial com FatureMais. <br />
                  <br />
                  <b>Conte conosco!</b>
                  <br />
                  <br />
                </label>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <Button
                  size="large"
                  className={classes.btnAvancar}
                  title="Quero começar"
                  variant="contained"
                  color="primary"
                  onClick={() => window.location.reload()}
                >
                  Quero começar
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12} />
          <br />
          <br />
          <br />
          <Grid container>
            <Grid item lg={5} md={5} sm={5} xs={5} />
            <Grid item lg={2} md={2} sm={2} xs={2}>
              {process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? (
                <Grid item className={classes.logoFatureMais}>
                  <img src="assets/images/logos/fature_mais_azul.svg" alt="logo" />
                </Grid>
              ) : (
                <Grid item className={classes.logoGroupFinanceiro}>
                  <img src="assets/images/logos/group_financeiro_azul.png" alt="logo" />
                </Grid>
              )}
            </Grid>
            <Grid item lg={5} md={5} sm={5} xs={5} />
          </Grid>
        </>
      }
    />
  );
};

export default FinalApresentacaoOnboarding;
